export default "__VITE_ASSET__6f3be863__"